/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacySlotTypename = "PharmacySlot" as const;

/**
 *
 * @export
 * @interface PharmacySlot
 */
export interface PharmacySlot {
  /**
   *
   * @type {string}
   * @memberof PharmacySlot
   */
  from: string;
  /**
   *
   * @type {number}
   * @memberof PharmacySlot
   */
  quota?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacySlot
   */
  to: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacySlot
   */
  readonly __typename?: string;
}

export function PharmacySlotFromJSON(json: any): PharmacySlot {
  return PharmacySlotFromJSONTyped(json, false);
}

export function PharmacySlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacySlot {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacySlotTypename,

    from: json["from"],
    quota: !exists(json, "quota") ? undefined : json["quota"],
    to: json["to"],
  };
}

export function PharmacySlotToJSON(object?: PharmacySlot | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    from: value.from,
    quota: value.quota,
    to: value.to,
  };
}
